import noop from '@gaia/util/noop/action'
import create from '@app/ticket/action/create'
import edit from '@app/ticket/action/edit'
import bulk from '@app/ticket/action/bulk'
import bulkForm from '@app/ticket/action/bulkForm'
import attachments from '@app/ticket/action/attachments'
import organisation from '@app/ticket/action/form/organisation'
import contact from '@app/ticket/action/form/contact'
import party from '@app/ticket/action/form/party'
import index from '@app/ticket/action/list'
import own from '@app/ticket/action/list/own'
import team from '@app/ticket/action/list/team'
import detail from '@app/ticket/action/detail/index'
import requester from '@app/ticket/action/detail/requester'
import device from 'app/ticket/action/detail/device'
import additionalParty from 'app/ticket/action/detail/additionalParty'
import description from '@app/ticket/action/detail/description'
import forward from '@app/ticket/action/quick/forward'
import postpone from '@app/ticket/action/quick/postpone'
import stop from '@app/ticket/action/quick/stop'
import close from '@app/ticket/action/quick/close'
import form from '@app/ticket/action/form'
import confirm from '@app/ticket/action/confirm'
import sendNote from '@app/ticket/action/sendNote'
import timeTracking from '@app/ticket/action/timeTracking'
import showAttachments from 'app/_shared/action/showAttachments'
import created from 'app/ticket/action/created'

export default {
  index,
  own,
  simple: index,
  unfiltered: noop,
  team,
  form,
  create,
  edit,
  organisation,
  contact,
  party,
  bulk,
  bulkForm,
  bulkEdit: bulk,
  sendNote,
  created,
  confirm,
  detail,
  requester,
  device,
  additionalParty,
  description,
  attachments,
  noteAttachments: noop,
  showAttachments,
  forward,
  postpone,
  close,
  reopen: noop,
  stop,
  timeTracking,
}
